import * as types from "../../constants/actionTypes";
import moment from 'moment';

const initState = {
    isLoading: false,
    listRekamMedisPasien: [],
    formDetailRekamMedis: {
        dataRekamMedis: {
            f_id_rekam_medis: "",
            f_kode_rekam_medis: "",
            f_tgl_buat: "",
            f_nama_poliklinik: "",
            f_nama_dokter: "",
            f_nama_pasien: "",
            f_no_identitas: "",
            f_diagnosa_icd: "",
            f_kode_icd: ""
        },
        listLayanan: [],
        listObat: [],
    },

    
};

export default function (state = initState, action) {
    switch (action.type) {
        case types.MODULE_KASIR_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.MODULE_REKAMMEDIS_LISTDATA_REKAMMEDIS_GET_SUCCESS: {
            return{
                ...state,
                listRekamMedisPasien: action.value
            }
        }
        case types.MODULE_REKAMMEDIS_DETAIL_REKAMMEDIS_GET_SUCCESS: {
            return{
                ...state,
                formDetailRekamMedis: {...initState.formDetailRekamMedis, ...action.value}
            }
        }
        default:
            return {
                ...state
            }
    }
}  